import create from "zustand";
import { WindowExecutionData } from "../components/FiltroAcompanhamentoOperacional/utils";

type Status = {
    emDia: boolean,
    proximo: boolean,
    atrasado: boolean,
};

interface MapState {
  mapInfo: any | null;
  datas: any[] | null;
  sidebarMenuOpen: boolean;
  listTalhoesIds: Set<string>;
  indicadoresDeDia: Set<string>;
  justificativaAtraso: boolean | null;
  ordemServico: boolean | null;
  rangeDates: any[];
  rangeDatesDeleted: any[];
  rangeWindows: WindowExecutionData[];
  numberRepeted: number[];
  semOS: boolean;
  arrayColorsAndDates: any[];
  janelaExecucao: boolean;
  statusSemaforo: Status;
  
  setDatas: (args: any) => void;
  setMapInfo: (args: any) => void;
  setSidebarMenuOpen: (args: any) => void;
  setListTalhoesIds: (args: any) => void;
  setIndicadoresDeDia: (args: any) => void;
  setJustificativaAtraso: (args: any) => void;
  setOrdemServico: (args: any) => void;
  setRangeDates: (args: any) => void;
  setRangeDatesDeleted: (args: any) => void;
  setRangeWindows: (args: WindowExecutionData[]) => void;
  setNumberRepeted: (args: any) => void;
  setSemOS: (args: any) => void;
  setArrayColorsAndDates: (args: any) => void;
  setJanelaExecucao: (args: any) => void;
  setStatusSemaforo: React.Dispatch<React.SetStateAction<Status>>;
}

const useMapData = create<MapState>((set) => ({
  mapInfo: null,
  datas: [],
  sidebarMenuOpen: true,
  listTalhoesIds: new Set(),
  indicadoresDeDia: new Set(),
  justificativaAtraso: null,
  ordemServico: null,
  rangeDates: [],
  rangeDatesDeleted: [],
  rangeWindows: [],
  numberRepeted: [],
  semOS: false,
  arrayColorsAndDates: [],
  janelaExecucao: false,
  statusSemaforo: {
      emDia: true,
      proximo: true,
      atrasado: true,
  },

  setMapInfo: (mapInfo) => {
    set(state => ({ mapInfo }));
  },
  setDatas: (datas) => {
    set(state => ({ datas }));
  },
  setSidebarMenuOpen: (sidebarMenuOpen) => {
    set(state => ({ sidebarMenuOpen }));
  },
 
  setListTalhoesIds: (listTalhoesIds) => {
    set(state => ({ listTalhoesIds }));
  },

  setIndicadoresDeDia: (indicadoresDeDia) => {
    set(state => ({ indicadoresDeDia }));
  },
  setJustificativaAtraso: (justificativaAtraso) => {
    set(state => ({ justificativaAtraso }));
  },

  setOrdemServico: (ordemServico) => {
    set(state => ({ ordemServico }));
  },

  setRangeDates: (rangeDates) => {
    set(state => ({ rangeDates }));
  },

  setRangeDatesDeleted: (rangeDatesDeleted) => {
    set(state => ({ rangeDatesDeleted }));
  },

  setRangeWindows: (rangeWindows) => {
    set(state => ({ rangeWindows }));
  },

  setNumberRepeted: (numberRepeted) => {
    set(state => ({ numberRepeted }));
  },
 
  setSemOS: (semOS) => {
    set(state => ({ semOS }));
  },

  setArrayColorsAndDates: (arrayColorsAndDates) => {
    set(state => ({ arrayColorsAndDates }));
  },

  setJanelaExecucao: (janelaExecucao) => {
    set(state => ({ janelaExecucao }));
  },

    setStatusSemaforo: (value) => {
      set((state) => ({
        statusSemaforo:
          typeof value === "function"
            ? value(state.statusSemaforo)
            : value,
      }));
  },
}));

export default useMapData;